import { MenuSection, NavigationItem } from '../types';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Link from '@/components/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import NextLink from 'next/link';

export default function DesktopDrawerContent({
  menuHeaders,
  openMenuIndex,
  onClose,
}: {
  menuHeaders: Array<NavigationItem & { title: string; sections: MenuSection[] }>;
  openMenuIndex: number | null;
  onClose: () => void;
}) {
  if (openMenuIndex === null || !menuHeaders[openMenuIndex]) return null;

  const menu = menuHeaders[openMenuIndex];
  return (
    <Box sx={{ p: 2, pl: '55px', maxWidth: 'lg', mx: 'auto', width: '100%' }}>
      <Grid container spacing={4} sx={{ justifyContent: 'flex-start' }}>
        {menu.sections.map((section, sectionIndex: number) => {
          if (sectionIndex === 0 && section.title && !section.hidden) {
            return (
              <Grid key='title'>
                <Link
                  href={section.links[0].href}
                  variant='h6'
                  color='text.primary'
                  sx={{ fontWeight: 'bold' }}
                >
                  {section.title}
                </Link>
              </Grid>
            );
          }

          if (!section.hidden) {
            return (
              <Grid key={sectionIndex}>
                <Stack direction='column' spacing={0.5} sx={{ p: 0, width: '100%' }}>
                  <Typography variant='body2' sx={{ color: 'primary.main' }}>
                    {section.title}
                  </Typography>
                  {section.links
                    .filter((link) => link.href)
                    .map((link, linkIndex: number) => {
                      const [productName, ...restOfText] = link.text.split(' ');

                      if (!link.hidden) {
                        return (
                          <Link
                            variant='body1'
                            key={linkIndex}
                            color='text.primary'
                            onClick={onClose}
                            component={NextLink}
                            href={link.href}
                            sx={{ display: 'flex', flexDirection: 'row', gap: '4px' }}
                          >
                            {[
                              'Products',
                              'Producten',
                              'Produits',
                              'Produkte',
                              'Productos',
                            ].includes(menu.title) ? (
                              <>
                                <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
                                  {productName}
                                </Typography>
                                <Typography variant='body1'>{restOfText.join(' ')}</Typography>
                              </>
                            ) : (
                              <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
                                {link.text}
                              </Typography>
                            )}
                          </Link>
                        );
                      }
                    })}
                </Stack>
              </Grid>
            );
          }
        })}
      </Grid>
    </Box>
  );
}
